import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { WorkGroupsService } from 'src/api/v2';

import { WORK_GROUPS_KEY } from 'src/constants/hook-keys';
import useCluster from 'src/features/cluster/hooks/use-cluster';

type UseWorkGroupsProps = {
  enabled?: boolean;
};

export default function useWorkGroups({ enabled }: UseWorkGroupsProps = { enabled: true }) {
  const { cluster } = useCluster();

  const [service] = useState(new WorkGroupsService());

  const { data, ...rest } = useQuery({
    queryKey: [WORK_GROUPS_KEY],
    queryFn: () => service.getAllFromCluster(cluster!.id),
    enabled: !!cluster && enabled,
  });

  return {
    workGroups: data || [],

    ...rest,
  };
}
